import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useIntl } from 'react-intl';

import CurrencyConverter from '../../CurrencyConverter';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';

import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const Total = (props) => {

    const { dayDifference, averagePrice, priceForDays, currency, isSpecialPriceAssigned } = props;
    const { formatMessage } = useIntl();

    return (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}>
                <div className='tooltipFlex'>
                    {isSpecialPriceAssigned && <ToolTipSection label={formatMessage(messages.averageRate)}
                        tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
                    <div>
                        <CurrencyConverter amount={averagePrice} from={currency} />
                        <span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
                    </div>
                </div>
            </div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                <CurrencyConverter amount={priceForDays} from={currency} />
            </div>
        </div>
    );
}

export default withStyles(cs, s)(Total);

